import axios from 'axios';

import mainVersionOneService from './mainVersionOneService';

const CancelToken = axios.CancelToken;

let cancel;

export function filterUserRecords(portId: number, data: object) {
    const formatFilter = (d) => {
        return Object.keys(d)
            .filter((v) => {
                return d[v] != null;
            })
            .map((v) => {
                return `${v}:${d[v]}`;
            })
            .join(',');
    };
    const formatSearch = (d) => {
        return Object.keys(d)
            .filter((v) => {
                return d[v] != null;
            })
            .map((v) => {
                return `${d[v]}`;
            })
            .join(',');
    };

    let parameters = '';

    for (const key in data) {
        const value = data[key];
        switch (key) {
            case 'order':
                parameters = `${parameters}&order=${value.type}.${value.order}`;
                break;
            case 'page':
                parameters = `${parameters}&page=${value}`;
                break;
            case 'limit':
                parameters = `${parameters}&limit=${value}`;
                break;
            case 'filter':
                if (Object.keys(value).length >= 1) {
                    parameters = `${parameters}&filter=${formatFilter(value)}`;
                }
                break;
            case 'search':
                if (Object.keys(value).length >= 1) {
                    parameters = `${parameters}&search=${formatSearch(value)}`;
                }
                break;
        }
    }

    return mainVersionOneService
        .get(`filters/${portId}/userRecords?rand=${new Date().getTime()}${parameters}`, {
            cancelToken: new CancelToken(function executor(c) {
                cancel = c;
            }),
        })
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function filterRecords(portId: number, data: object) {
    if (cancel !== undefined) {
        cancel();
    }
    const formatFilter = (d) => {
        return Object.keys(d)
            .filter((v) => {
                return d[v] != null;
            })
            .map((v) => {
                return `${v}:${d[v]}`;
            })
            .join(',');
    };
    const formatSearch = (d) => {
        return Object.keys(d)
            .filter((v) => {
                return d[v] != null;
            })
            .map((v) => {
                return `${d[v]}`;
            })
            .join(',');
    };

    let parameters = '';

    for (const key in data) {
        const value = data[key];
        switch (key) {
            case 'order':
                parameters = `${parameters}&order=${value.type}.${value.order}`;
                break;
            case 'page':
                parameters = `${parameters}&page=${value}`;
                break;
            case 'limit':
                parameters = `${parameters}&limit=${value}`;
                break;
            case 'filter':
                if (Object.keys(value).length >= 1) {
                    parameters = `${parameters}&filter=${formatFilter(value)}`;
                }
                break;
            case 'search':
                if (Object.keys(value).length >= 1) {
                    parameters = `${parameters}&search=${formatSearch(value)}`;
                }
                break;
        }
    }

    return mainVersionOneService
        .get(`filters/${portId}/records?rand=${new Date().getTime()}${parameters}`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function filterDelete(portId: number, id: number) {
    return mainVersionOneService
        .delete(`filters/${portId}/${id}/delete`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function filterRecord(portId: number, id: number) {
    return mainVersionOneService
        .get(`filters/${portId}/${id}`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function filterUpdate(portId: number, id: number, data: object) {
    return mainVersionOneService
        .put(`filters/${portId}/${id}/update`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function filterCreate(portId: number, data: object) {
    return mainVersionOneService
        .post(`filters/${portId}/create`, { port_id: portId, ...data })
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
